import { useEffect, useState } from "react";

/** The phone breakpoint from styles.css: below it the shell is a strip and the map goes fullscreen. */
export const PHONE = "(max-width: 639px)";

/**
 * True while the viewport matches `query`. Where `matchMedia` is missing — jsdom in the tests — it
 * stays false, so the desktop layout is what renders there.
 */
export function useMediaQuery(query: string): boolean {
  const [matches, setMatches] = useState(() => window.matchMedia?.(query).matches ?? false);
  useEffect(() => {
    const mq = window.matchMedia?.(query);
    if (!mq) return;
    setMatches(mq.matches);
    const on = (e: MediaQueryListEvent) => setMatches(e.matches);
    mq.addEventListener("change", on);
    return () => mq.removeEventListener("change", on);
  }, [query]);
  return matches;
}
